import { shopPrefix } from '../../config';
import { http } from '../axios';
import { BulkAddProductsToShoppingCartResponse } from '../../store/api';
import { ProductFilter } from '../../../models/Product';
import { SubscriptionPeriodType } from '../../../models/Article';
import { LoanFormatDto } from '../../../models/LoanFormatDto';

export type BulkAddProductsByFilterWithProductTypeRequest = {
    loanFormat: LoanFormatDto;
    productType: string;
    filterRequest: ProductFilter;
    excludedProductIds: string[];
    targetPrice: string;
    subscriptionPeriodType: SubscriptionPeriodType;
    ageCategory?: string;
};

type Params = {
    performChecks: boolean;
};

const url = `${shopPrefix}/v2/shoppingcart/bulk/catalogue/filter-product-type/add`;

export const addProductsFromProducTypeByFilter = (
    body: BulkAddProductsByFilterWithProductTypeRequest,
    params: Params
) => {
    return http
        .post<BulkAddProductsToShoppingCartResponse>(url, body, {
            params
        })
        .then(res => res.data);
};
